import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn } from 'intact-react';
import { addStyle, getRestProps } from '../utils';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    style = _this$get.style,
    size = _this$get.size,
    color = _this$get.color,
    rotate = _this$get.rotate,
    hoverable = _this$get.hoverable,
    children = _this$get.children,
    disabled = _this$get.disabled;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-icon"] = true, _classNameObj[k + "-rotate"] = rotate, _classNameObj[k + "-hoverable"] = !disabled && hoverable, _classNameObj[k + "-disabled"] = disabled, _classNameObj[className] = className, _classNameObj);
  var _style = {};
  if (/^\d+$/.test(size)) {
    _style.fontSize = size + 'px';
  } else if (size !== 'default') {
    classNameObj[k + "-" + size] = true;
  }
  if (this.colors.indexOf(color) > -1) {
    classNameObj[k + "-" + color] = color !== 'default';
    classNameObj[makeStyles(k)] = true;
  } else if (color) {
    _style.color = color;
    classNameObj[makeStyles(k, color)] = true;
  } else {
    classNameObj[makeStyles(k)] = true;
  }
  return _$cv('i', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this), {
    'style': addStyle(style, _style)
  }), children);
}
;